import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { viewPDF } from "../../../utils/viewPDF";
import ErrorModal from "../../../utils/ErrorModal";
import { uploadFile } from "../../../utils/uploadToAzure";

const Step5 = ({ tender, setTender, user, setStep, filename, setFilename }) => {
  const [errors, setErrors] = useState({});
  const [uploadLoading, setUploadLoading] = useState({
    ts1: false,
    ts2: false,
    ts3: false,
    ts4: false,
    ts5: false,
    ts6: false,
    ts7: false,
    ts8: false,
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const orgId = JSON.parse(localStorage.getItem("org"));

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const setFieldLoading = (field, isLoading) => {
    setUploadLoading((prev) => ({
      ...prev,
      [field]: isLoading,
    }));
  };

  const setFileNames = (field, filename) => {
    setFilename((prev) => ({
      ...prev,
      [field]: filename,
    }));
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const field = e.target.name;

    if (!file) return;

    setFieldLoading(field, true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await uploadFile(file, orgId, tender.draftTenderId, user)
      // Set the received file path in tender state
      setTender({ ...tender, [e.target.name]: res });
      setFileNames(field, file.name);
    } catch (error) {
      console.log(error)
    } finally {
      setFieldLoading(e.target.name, false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.ts1Title)) newErrors.ts1Title = "TS-1 Title is required";
    if (isEmpty(data.ts1)) newErrors.ts1 = "TS-1 is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftTenderId=${tender.draftTenderId}`,
        {
          ts1Title: tender.ts1Title,
          ts1Filename: filename.ts1,
          ts1: tender.ts1,
          ts2Title: tender.ts2Title,
          ts2Filename: filename.ts2,
          ts2: tender.ts2,
          ts3Title: tender.ts3Title,
          ts3Filename: filename.ts3,
          ts3: tender.ts3,
          ts4Title: tender.ts4Title,
          ts4Filename: filename.ts4,
          ts4: tender.ts4,
          ts5Title: tender.ts5Title,
          ts5Filename: filename.ts5,
          ts5: tender.ts5,
          ts6Title: tender.ts6Title,
          ts6Filename: filename.ts6,
          ts6: tender.ts6,
          ts7Title: tender.ts7Title,
          ts7Filename: filename.ts7,
          ts7: tender.ts7,
          ts8Title: tender.ts8Title,
          ts8Filename: filename.ts8,
          ts8: tender.ts8,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      setTender(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Create New Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "83%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Technical Specifications</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts1">
              TS-1 <span style={{ color: "red" }}>*</span>
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts1Title"
                  name="ts1Title"
                  value={tender && tender?.ts1Title}
                  onChange={handleChange}
                  className={`${errors.ts1Title && "input-error"}`}
                />
                <input
                  type="file"
                  id="ts1"
                  name="ts1"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS1 File Upload</span>
              </div>
              {errors.ts1Title && <p className="error">{errors.ts1Title}</p>}
              {errors.ts1 && <p className="error">{errors.ts1}</p>}
              {uploadLoading.ts1 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
              {tender && tender.ts1 && (
                <Button
                  sx={{
                    margin: "-6% 0 0 0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(tender.ts1, user)}
                >
                  {tender.ts1Filename || filename.ts1}
                </Button>
              )}
            </label>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts2">
              TS-2
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts2Title"
                  name="ts2Title"
                  value={tender && tender?.ts2Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts2"
                  name="ts2"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS2 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts2 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}

            {tender && tender.ts2 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts2, user)}
              >
                {tender.ts2Filename || filename.ts2}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts3">
              TS-3
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts3Title"
                  name="ts3Title"
                  value={tender && tender?.ts3Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts3"
                  name="ts3"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS3 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts3 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts3 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts3, user)}
              >
                {tender.ts3Filename || filename.ts3}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts4">
              TS-4
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts4Title"
                  name="ts4Title"
                  value={tender && tender?.ts4Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts4"
                  name="ts4"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS4 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts4 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts4 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts4, user)}
              >
                {tender.ts4Filename || filename.ts4}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts5">
              TS-5
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts5Title"
                  name="ts5Title"
                  value={tender && tender?.ts5Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts5"
                  name="ts5"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS5 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts5 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts5 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts5, user)}
              >
                {tender.ts5Filename || filename.ts5}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts6">
              TS-6
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts6Title"
                  name="ts6Title"
                  value={tender && tender?.ts6Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts6"
                  name="ts6"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS6 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts6 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts6 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts6, user)}
              >
                {tender.ts6Filename || filename.ts6}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts7">
              TS-7
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts7Title"
                  name="ts7Title"
                  value={tender && tender?.ts7Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts7"
                  name="ts7"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS7 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts7 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts7 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts7, user)}
              >
                {tender.ts7Filename || filename.ts7}
              </Button>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ts8">
              TS-8
              <div style={{ display: "flex", gap: 5 }}>
                <input
                  type="text"
                  id="ts8Title"
                  name="ts8Title"
                  value={tender && tender?.ts8Title}
                  onChange={handleChange}
                />
                <input
                  type="file"
                  id="ts8"
                  name="ts8"
                  onChange={handleFileUpload}
                />
                <span className="ts-file">TS8 File Upload</span>
              </div>
            </label>
            {uploadLoading.ts8 && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {tender && tender.ts8 && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(tender.ts8, user)}
              >
                {tender.ts8Filename || filename.ts8}
              </Button>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>

      <ErrorModal open={errorOpen} handleClose={() => setErrorOpen(false)} msg={errorMsg} />
    </div>
  );
};

export default Step5;
